import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { LogoLoadingScreen } from '@/components/loading/LogoLoadingScreen';

// i18n
import './lib/i18n/i18n';

// Tailwind css
import './tailwind.css';
// Leaflet map tiles / panes positioning (required for react-leaflet)
import 'leaflet/dist/leaflet.css';

// Router
import { RouterProvider } from 'react-router-dom';
import './lib/axios/axios-global';
import router from './core/global-router';
import { Provider } from 'react-redux';
import store from './core/global-store';
import LangSettings from './lib/i18n/LangSettings';
import { Toaster } from './components/ui/sonner';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './components/theme-provider';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <HelmetProvider>
        <Provider store={store}>
            <LangSettings>
                <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
                    <Suspense fallback={<LogoLoadingScreen variant="fullscreen" />}>
                        <RouterProvider router={router} />
                        <Toaster />
                    </Suspense>
                </ThemeProvider>
            </LangSettings>
        </Provider>
    </HelmetProvider>,
);
